"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setItem = exports.clearItem = exports.getItem = void 0;
const react_1 = require("react");
const usePersistedState = (keyName, initState) => {
    const key = `PERSIST_STATE_${keyName}`;
    const [state, setState] = (0, react_1.useState)(initState);
    const [isInitLoaded, setIsInitLoaded] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        const initData = (0, exports.getItem)(key);
        if (!!initData)
            setState(initData);
        setIsInitLoaded(true);
    }, []);
    (0, react_1.useEffect)(() => {
        if (isInitLoaded)
            (0, exports.setItem)(key, state);
    }, [keyName, state, initState]);
    return [state, setState];
};
const getItem = (key) => {
    if (!localStorage)
        return undefined;
    const value = localStorage.getItem(key);
    if (value)
        return JSON.parse(value);
    return undefined;
};
exports.getItem = getItem;
const clearItem = (key) => localStorage.removeItem(key);
exports.clearItem = clearItem;
const setItem = (key, value) => localStorage.setItem(key, JSON.stringify(value));
exports.setItem = setItem;
exports.default = usePersistedState;
